import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_memory'

export default function DreamMemoryPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How often do you remember dreams after waking?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamMemory.heading')}
      buttons={[
        {
          text: `🔮 ${t('pages.onboarding.dreamMemory.options.everyMorning')}`,
          value: 'Every morning – it’s a whole movie',
        },
        {
          text: `🌘 ${t('pages.onboarding.dreamMemory.options.fewTimesWeek')}`,
          value: 'A few times a week',
        },
        {
          text: `😵 ${t('pages.onboarding.dreamMemory.options.rarelyFragments')}`,
          value: 'Rarely – just fragments',
        },
        {
          text: `🫠 ${t('pages.onboarding.dreamMemory.options.almostNever')}`,
          value: 'Almost never – help me remember!',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
